import weightRestrictions from "consts/weight-restrictions.json";

/**
 * Validates if the weight is within the acceptable range for the given return method (mail or instore) and unit (kg or lbs)
 * @param {number} weight - The weight to validate
 * @param {string} method - The return method ("mail" or "instore")
 * @param {string} unit - The unit of weight ("kg" or "lbs")
 * @param {string} state - The state code (e.g. "AR", "CO", "NJ", "PA")
 * @param {number} donationWeight - The weight of the donation, if any
 * @returns {boolean} - Returns true if the weight is valid, otherwise false
 */

export function isValidWeight(weight, method, unit, state, donationWeight) {
  // Check if the weight is zero or negative
  if (weight <= 0) {
    console.error("Weight must be a positive number");
    return false;
  }

  const restriction = weightRestrictions.find((r) => r.unit === unit);

  if (!restriction) {
    console.error(`Unsupported unit: ${unit}`);
    return false;
  }

  // First check donation restriction if applicable
  if (donationWeight) {
    // For donations, the weight must match exactly and be within donation limit
    if (donationWeight > restriction.maxDonation) {
      return false;
    }
  }

  // Then check method and state based restrictions
  let max;
  if (method === "mail") {
    max = restriction.maxMail;
  } else if (state === "AR" || state === "CO") {
    max = restriction.maxKiosk;
  } else if (state === "NJ" || state === "PA") {
    max = restriction.maxDropOff;
  } else {
    max = restriction.maxDropOff; // Default to maxDropOff for other states
  }

  // Check if the weight is valid
  return weight <= max;
}

/**
 * Validates if the payout method is valid based on the provided valid payout methods.
 * @param {string} payoutMethod - The payout method to validate.
 * @param {Array<string>} validMethods - An array of valid payout methods.
 * @returns {boolean} - Returns true if the payout method is valid, otherwise false.
 */
export function isValidPayoutMethod(payoutMethod, validMethods) {
  return validMethods.includes(payoutMethod);
}
